module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "related_items_table",
    attrs: {
      "parentStyle": " ",
      "id": "related-items-table",
      "dtOptions": _vm.dtOptionsRelatedItems,
      "dtHeaders": _vm.dtHeadersRelatedItems
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('WeakLinks', {
    ref: "weak_links_lookup",
    attrs: {
      "readonlyForm": _vm.readonlyForm,
      "displayedEntityType": _vm.displayedEntityType,
      "displayedEntityId": _vm.displayedEntityId
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69dc75d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/related_items.vue
// module id = 1003
// module chunks = 0